import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import * as actions from '../actions';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_COMPANY_SUCCESS:
    case actions.REQUEST_COMPANY_STRUCTURE_SUCCESS:
    case actions.REQUEST_COMPANY_BUDGETS_SUCCESS:
    case actions.EDIT_COMPANY_SUCCESS:
    case actions.RESEND_ACCOUNT_ACTIVATION_EMAIL_SUCCESS:
      return Object.assign({}, state, action.data.entities.countries || {});
    case actions.REQUEST_COMPANYLIST_SUCCESS:
      return Object.assign({}, state, action.data.items.entities.countries);
    case actions.REQUEST_ORDER_SUCCESS:
    case actions.PLACE_ORDER_NATIONAL_SUCCESS:
    case actions.REQUEST_QUESTIONNAIRE_SUCCESS:
    case actions.UPDATE_QUESTIONNAIRE_SUCCESS:
    case actions.SEND_QUESTIONNAIRE_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.countries);
    default:
      return Object.assign({}, state);
  }
}

const countries = combineReducers({
  byId,
});

export default countries;

export const $getAllCountries = state => state.countries.byId;
export const $getCountryById = (state, id) => state.companies.byId[id];

export const getCountryById = createSelector(
  $getAllCountries, $getCountryById,
  $country => $country);
